import store from '../redux/store';
import { DocumentAny, StructureViewMode } from '../types';
import { ICategoryFields } from '../components/General/ImportTable/ImportTableCategoryCell';
import { IProjectDocType } from '../redux/project/sliceProjectDocTypes';

export const fallbackDocType = '#Document#_Default';

const getProjectDocuments = (areaName: string) => {
    const state = store.getState();
    return areaName === 'import'
        ? state.importDocuments.data
        : [...state.projectDocuments.data, ...state.projectAdvancedSearch.data];
};

export const findProjectDocument = (universalId: string, areaName: string) => {
    return getProjectDocuments(areaName)?.find(x => x.UniversalID === universalId) ?? null;
};

export const findProjectDocuments = (universalIds: string[], areaName: string) => {
    return getProjectDocuments(areaName)?.filter(x => universalIds.includes(x.UniversalID)) ?? [];
};

/**
 * Returns the document's "DocType" field value or the fallback value "#Document#_Default".
 */
export const getDocTypeOrDefault = (doc: DocumentAny, docTypes?: IProjectDocType[]): string => {
    !docTypes && (docTypes = store.getState().projectDocTypes.data);

    if (doc && docTypes?.length) {
        const docType = doc.DocType ?? doc.docType ?? doc['docType'];

        if (docType && typeof docType === 'string' && docTypes.some(x => x.name === docType)) {
            return docType;
        }
    }

    return fallbackDocType;
};

export const getDocFieldAsArray = (doc: DocumentAny, field: string): string[] => {
    if (!doc || !field || !doc[field]) {
        return [];
    }

    return [].concat(doc[field]);
};

export const getDocStructureFields = (
    doc: DocumentAny,
    view: StructureViewMode,
): ICategoryFields[] => {
    switch (view) {
        case 'Category':
            return getDocCategories(doc);
        case 'Package':
            return getDocPackages(doc);
        case 'Keyword':
            return getDocKeywords(doc);
        case 'Address':
            return getDocAddresses(doc);
        default:
            return [];
    }
};

export const getDocCategories = (doc: DocumentAny): ICategoryFields[] => {
    const ids = getDocFieldAsArray(doc, 'CategoryID');
    const subjects = getDocFieldAsArray(doc, 'Category');

    return ids.map((id, index) => ({
        Id: id,
        FullPath: subjects[index],
    }));
};

export const getDocPackages = (doc: DocumentAny): ICategoryFields[] => {
    const ids = getDocFieldAsArray(doc, 'PackageID');
    const subjects = getDocFieldAsArray(doc, 'Package');

    return ids.map((id, index) => ({
        Id: id,
        FullPath: subjects[index],
    }));
};

export const getDocKeywords = (doc: DocumentAny): ICategoryFields[] => {
    const ids = getDocFieldAsArray(doc, 'KeywordID');
    const subjects = getDocFieldAsArray(doc, 'Keyword');

    return ids.map((id, index) => ({
        Id: id,
        FullPath: subjects[index],
    }));
};

export const getDocAddresses = (doc: DocumentAny): ICategoryFields[] => {
    const ids = getDocFieldAsArray(doc, 'AddressID');
    const subjects = getDocFieldAsArray(doc, 'Address');

    return ids.map((id, index) => ({
        Id: id,
        FullPath: subjects[index],
    }));
};
